import { BEBusinessLogic } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEBusinessLogic';
import { EnumBEType } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumBEType';

export class BEBusinessLogicExtend {
  public static Init(dto: BEBusinessLogic) {
    dto.bEType = EnumBEType.BEBusinessLogic;
  }
}
